import React from "react";

function ShopPage() {
    return (
        <div className="container">
            <div className="hero-block">
                <div className="hero-heading-wrap">
                    <div className="hero-icon is-shop">
                        <div className="icon-svg w-embed">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                 className="w-6 h-6">
                                <path fill-rule="evenodd"
                                      d="M7.5 6v.75H5.513c-.96 0-1.764.724-1.865 1.679l-1.263 12A1.875 1.875 0 004.25 22.5h15.5a1.875 1.875 0 001.865-2.071l-1.263-12a1.875 1.875 0 00-1.865-1.679H16.5V6a4.5 4.5 0 10-9 0zM12 3a3 3 0 00-3 3v.75h6V6a3 3 0 00-3-3zm-3 8.25a3 3 0 106 0v-.75a.75.75 0 011.5 0v.75a4.5 4.5 0 11-9 0v-.75a.75.75 0 011.5 0v.75z"
                                      clip-rule="evenodd"/>
                            </svg>
                        </div>
                    </div>
                    <h1 className="hero-heading">Responsive website templates</h1>
                </div>
                <div className="text-lead">Choose from over 50 business, portfolio, and blog templates you can
                    customize with Webflow &#x27;s code-free design tools.
                </div>
            </div>
            <div className="block-divider"></div>
            <div className="section-block">
                <div className="w-dyn-list">
                    <div role="list" className="_2x-column w-dyn-items">
                        <div role="listitem" className="cms-item w-dyn-item">
                            <a data-w-id="1ad1ef05-0c6a-6537-43dc-ddc43069d9be" href="/product/moss"
                               className="product-card w-inline-block">
                                <div className="shine-wrap">
                                    <div className="shine"></div>
                                </div>
                                <div className="product-card-content">
                                    <div className="product-thumb">
                                        <img loading="lazy"
                                             src="https://assets.website-files.com/641485e797229d5a5b67f8ad/644f6ac09964647df8fb9799_malik-skydsgaard-kUqD6pkMYfI-unsplash%20(1)%201%20(2)%20(1).jpg"
                                             alt=""
                                             sizes="(max-width: 479px) 93vw, (max-width: 767px) 96vw, (max-width: 991px) 46vw, 31vw"
                                             srcSet="https://assets.website-files.com/641485e797229d5a5b67f8ad/644f6ac09964647df8fb9799_malik-skydsgaard-kUqD6pkMYfI-unsplash%20(1)%201%20(2)%20(1)-p-500.jpg 500w, https://assets.website-files.com/641485e797229d5a5b67f8ad/644f6ac09964647df8fb9799_malik-skydsgaard-kUqD6pkMYfI-unsplash%20(1)%201%20(2)%20(1)-p-800.jpg 800w, https://assets.website-files.com/641485e797229d5a5b67f8ad/644f6ac09964647df8fb9799_malik-skydsgaard-kUqD6pkMYfI-unsplash%20(1)%201%20(2)%20(1).jpg 853w"
                                             className="thumb-image"/>
                                        <div className="thumb-outline"></div>
                                    </div>
                                    <div className="shop-thumb-head">
                                        <div className="tools-icon">
                                            <img loading="lazy"
                                                 src="https://assets.website-files.com/641485e797229d5a5b67f8ad/6422ab46bb1a99447cad9fd5_HQnL-L9Y_400x400.jpeg"
                                                 alt="" className="image-background"/>
                                            <div className="app-outline"></div>
                                        </div>
                                        <div>
                                            <h2 className="card-heading">Moss</h2>
                                            <div className="card-text-2-lines">Moss portfolio has a a bold,
                                                modern design, a clean user experience and advanced Webflow
                                                interactions.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div role="listitem" className="cms-item w-dyn-item">
                            <a data-w-id="1ad1ef05-0c6a-6537-43dc-ddc43069d9be" href="/product/bergen"
                               className="product-card w-inline-block">
                                <div className="shine-wrap">
                                    <div className="shine"></div>
                                </div>
                                <div className="product-card-content">
                                    <div className="product-thumb">
                                        <img loading="lazy"
                                             src="https://assets.website-files.com/641485e797229d5a5b67f8ad/644f6b176b84f3ea0a192339_tyler-nix-6b5Hhx83Tbo-unsplash%201%20(1).jpg"
                                             alt=""
                                             sizes="(max-width: 479px) 93vw, (max-width: 767px) 96vw, (max-width: 991px) 46vw, 31vw"
                                             srcSet="https://assets.website-files.com/641485e797229d5a5b67f8ad/644f6b176b84f3ea0a192339_tyler-nix-6b5Hhx83Tbo-unsplash%201%20(1)-p-500.jpg 500w, https://assets.website-files.com/641485e797229d5a5b67f8ad/644f6b176b84f3ea0a192339_tyler-nix-6b5Hhx83Tbo-unsplash%201%20(1)-p-800.jpg 800w, https://assets.website-files.com/641485e797229d5a5b67f8ad/644f6b176b84f3ea0a192339_tyler-nix-6b5Hhx83Tbo-unsplash%201%20(1).jpg 853w"
                                             className="thumb-image"/>
                                        <div className="thumb-outline"></div>
                                    </div>
                                    <div className="shop-thumb-head">
                                        <div className="tools-icon">
                                            <img loading="lazy"
                                                 src="https://assets.website-files.com/641485e797229d5a5b67f8ad/6422ab46bb1a99447cad9fd5_HQnL-L9Y_400x400.jpeg"
                                                 alt="" className="image-background"/>
                                            <div className="app-outline"></div>
                                        </div>
                                        <div>
                                            <h2 className="card-heading">Bergen</h2>
                                            <div className="card-text-2-lines">Clean editorial design look, full
                                                screen images, advanced Webflow interactions and a versatile
                                                grid.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ShopPage